import ApiService from './ApiService';
class ShareHoldingService {
  async getTradingAccountDetail(payload) {
    try {
      const response = await ApiService.call(
        '/secured/get_trading_account_detail',
        'POST',
        payload,
      );
      return {
        success: true,
        data: response,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }
}

export default new ShareHoldingService();
